export default {"src":"/_next/static/media/BWB.fa174f51.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};